import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import './index.scss';

interface EfOurAwardsProps {
    /**
     * title
     */
    title?: string;
    /**
     * items
     */
    items?: string[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护: kalkin
 *
 * 主标题
 */
const EfOurAwards: React.FC<EfOurAwardsProps> = ({ className, title, items }) => {
    const prefixCls = `ef-our-awards`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    const awards =
        items?.length > 0
            ? items
            : [
                  'https://websiteoss.ecoflow.com/upload/image/1726108488073/CES2024.png',
                  'https://websiteoss.ecoflow.com/upload/image/1726108488661/MakeUseOf.png',
                  'https://websiteoss.ecoflow.com/upload/image/1726108488875/IF.png',
                  'https://websiteoss.ecoflow.com/upload/image/1726108488270/RedDot.png',
                  'https://websiteoss.ecoflow.com/upload/image/1726108489097/CNN_underscored.png',
                  'https://websiteoss.ecoflow.com/upload/image/1726108488472/TimeBestInventions.png',
              ];

    return (
        <div className={classes}>
            {title && <p className={`${prefixCls}-title`}>{title}</p>}
            <ul className={`${prefixCls}-items`}>
                {awards.map((img: string, index: number) => (
                    <li className={`${prefixCls}-item`}>
                        <EfImg pc={img} />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EfOurAwards;
